<template>
    <view-card title="기업 소개" v-if="expert">
        <data-list :dataList="dataList">
            <v-col tag="li" cols="12" class="py-0">
                <dt>사업분야</dt>
                <dd><item-area-badges :areas="expert.areas" /></dd>
            </v-col>
            <v-col tag="li" cols="12" class="py-0">
                <dt>기업소개</dt>
                <dd>{{ expert.summary }}</dd>
            </v-col>
            <v-col tag="li" cols="12" class="py-0">
                <dt>소개자료</dt>
                <dd><view-brochures :brochures="expert.brochures" /></dd>
            </v-col>
        </data-list>
    </view-card>
</template>

<script>
import DataList from "./data-list.vue";
import ViewCard from "./view-card.vue";
import ViewBrochures from "./view-brochures.vue";
import ItemAreaBadges from "./item-area-badges.vue";

export default {
    components: {
        DataList,
        ViewCard,
        ViewBrochures,
        ItemAreaBadges,
    },
    props: {
        expert: Object,
    },
    computed: {
        dataList() {
            const list = [];

            if (this.expert) {
                const { ceoName, establishedAt, website, phone, postcode, address1, address2 } = this.expert;

                if (ceoName) list.push({ term: "대표자", description: ceoName, cols: 6 });
                if (establishedAt) list.push({ term: "설립일", description: establishedAt.toDate(), cols: 6 });
                if (website) list.push({ term: "홈페이지", description: website, cols: 6 });
                if (phone) list.push({ term: "연락처", description: phone, cols: 6 });
                if (postcode && address1) list.push({ term: "주소", description: `(${postcode}) ${address1} ${address2}` });
            }

            return list;
        },
    },
};
</script>

<style></style>
